import ApiService from './ApiService'
import { API_URL } from 'components/ui/utils/constant'

const API = `${API_URL}/clients`

/**
 * Get all clients (admin only)
 */
export async function apiGetClients(data) {
    // Serialize sort object to JSON string if it's an object
    const params = { ...data }
    if (params.sort && typeof params.sort === 'object') {
        params.sort = JSON.stringify(params.sort)
    }
    return ApiService.fetchData({
        url: API,
        method: 'GET',
        params, // Use params for GET requests query parameters
    })
}

/**
 * Get a single client by ID
 */
export async function apiGetClient(id) {
    return ApiService.fetchData({
        url: `${API}/${id}`,
        method: 'GET',
    })
}

/**
 * Create a new client
 */
export async function apiCreateClient(data) {
    return ApiService.fetchData({
        url: API,
        method: 'POST',
        data,
    })
}

/**
 * Update a client
 */
export async function apiEditClient(id, data) {
    return ApiService.fetchData({
        url: `${API}/${id}`,
        method: 'PATCH',
        data,
    })
}

/**
 * Delete a client
 */
export async function apiDeleteClient(id) {
    return ApiService.fetchData({
        url: `${API}/${id}`,
        method: 'DELETE',
    })
}

/**
 * Update client plan
 */
export async function apiUpdatePlanClient(data) {
    return ApiService.fetchData({
        url: `${API}/plan`,
        method: 'PATCH',
        data,
    })
}

/**
 * Update client password by admin
 */
export async function apiUpdatePasswordAdmin(data) {
    const { id, ...passwordData } = data
    return ApiService.fetchData({
        url: `${API}/password/${id}`,
        method: 'PATCH',
        data: passwordData,
    })
}

/**
 * Update client password by client
 */
export async function apiUpdatePasswordClient(data) {
    // Handle both { data: {...}, id: ... } and { ...passwordData, id: ... } formats
    const { id, data: nestedData, ...passwordData } = data
    const finalPasswordData = nestedData || passwordData
    
    return ApiService.fetchData({
        url: `${API}/me/password/${id}`,
        method: 'PATCH',
        data: finalPasswordData,
    })
}

/**
 * Get current authenticated client data with updated available_days
 * This is useful to refresh user data after payment or other updates
 */
export async function apiGetMe() {
    return ApiService.fetchData({
        url: `${API}/me`,
        method: 'GET',
    })
}

/**
 * Get client plans for the authenticated client
 * Returns all plans with expiration dates and status
 */
export async function apiGetMyPlans() {
    return ApiService.fetchData({
        url: `${API}/me/plans`,
        method: 'GET',
    })
}

/**
 * Get last plan for a client (admin only)
 * @param {string} clientId - Client ID to get last plan for
 */
export async function apiGetClientLastPlan(clientId) {
    return ApiService.fetchData({
        url: `${API}/${clientId}/last-plan`,
        method: 'GET',
    })
}

/**
 * Update plan days for a client (admin only)
 * @param {string} clientId - Client ID
 * @param {number} availableDays - New available days count
 */
export async function apiUpdatePlanDays(clientId, availableDays) {
    return ApiService.fetchData({
        url: `${API}/${clientId}/plan-days`,
        method: 'PATCH',
        data: { available_days: availableDays },
    })
}

/**
 * Get plan history for a client (admin only)
 * Returns all plans purchased by the client with plan and payment information
 * @param {string} clientId - Client ID to get plan history for
 */
export async function apiGetClientPlanHistory(clientId) {
    return ApiService.fetchData({
        url: `${API}/${clientId}/plan-history`,
        method: 'GET',
    })
}
